<app-badge>
  <mat-icon class="period-icon">date_range</mat-icon>
  <app-datepicker-period [period]="parameter"></app-datepicker-period>
</app-badge>
